<template>
  <div v-if="validTabs.length" class="tab-component">
    <div class="container">
      <nav class="nav nav-pills flex-column flex-sm-row d-flex flex-wrap">
        <a
          v-for="(data, index) in validTabs"
          :key="index"
          :class="
            data.class[0].toLowerCase().trim().includes('technical_user')
              ? 'text-sm-center nav-link newclass'
              : 'text-sm-center nav-link'
          "
          :href="
            `#${encodeURI(
              data.description
                .toLowerCase()
                .trim()
                .replaceAll(' ', '-')
            ).replaceAll('%', '')}`
          "
        >
          {{ data.name }}
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
export default {
  name: "tabComponent",

  data() {
    return {
      tabHeaders: [],
      sticky: {
        active: false,
        allowed: false,
        direction: "",
        i: 0,
      },
    };
  },

  methods: {
    debounce: debounce(function() {
      this.sticky.allowed = (window.pageYOffset || window.scrollY) > 200; // threshold

      if ($(window).scrollTop() < 200) {
        $(".tab-component").addClass("tabComponent transition-in");
        $(".tab-component").removeClass(
          "tabComponentStickyTop tabComponentSticky transition-out"
        );
      }

      this.sticky.direction =
        document.body.getBoundingClientRect().top > this.sticky.i
          ? "up"
          : "down";
      this.sticky.i = document.body.getBoundingClientRect().top;

      if (this.sticky.allowed && this.sticky.direction === "up") {
        // if (
        //   $(window).scrollTop() >= scrollAmount &&
        //   $("div").hasClass("is-sticky")
        // ) {
        $(".tab-component")
          .addClass("tabComponentStickyTop transition-allowed transition-in")
          .removeClass("tabComponent tabComponentSticky transition-out");
      } else {
        if (this.sticky.allowed) {
          $(".tab-component")
            .addClass("tabComponentSticky")
            .removeClass("tabComponent tabComponentStickyTop");
        } else {
          $(".tab-component").removeClass(
            "tabComponentSticky tabComponent tabComponentStickyTop"
          );
        }
      }

      // hide on footer
      if (
        $(window).scrollTop() + $(window).height() >=
        $(document).height() - 200
      ) {
        $(".tab-component").css("display", "none");
      } else {
        $(".tab-component").css("display", "block");
      }
    }),
  },
  computed: {
    validTabs() {
      const tabs = this.tabHeaders.filter((item) => {
        const encoded = $(
          `#${encodeURI(
            item.description
              .toLowerCase()
              .trim()
              .replaceAll(" ", "-")
          ).replaceAll("%", "")}`
        );
        // console.log("encoded", encoded);
        if (encoded.length) {
          return item;
        }
      });
      return tabs;
    },
  },

  async mounted() {
    if ($("#helpful-documents")) {
      // console.log('exists');
    }
    const data = await axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}/${
        this.$route.params.region
      }/wp-json/resmed/v1/navigation/tab-header`
    );

    this.tabHeaders = data.data;
    // console.log('tab headers',this.tabHeaders);
    window.addEventListener("scroll", () => {
      this.debounce();
    });

    $(document).ready(function() {
      // default - selected item
      $(".nav-link:first-child").addClass("active");

      // add/remove active class on click
      $("a.nav-link").on("click", function(event) {
        if ($(this).hasClass("active")) {
          return;
        }

        $(".nav-link").removeClass("active");
        $(this).addClass("active");

        // this updates the url after completing the scroll.
        if (this.hash !== "") {
          event.preventDefault();
          var hash = this.hash;

          $("html, body").animate(
            {
              scrollTop: $(hash).offset().top,
            },
            800,
            function() {
              window.location.hash = hash;
            }
          );
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.tabComponentSticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100% !important;
  z-index: 102;
  padding-top: 14px;
}

.tabComponentStickyTop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100% !important;
  z-index: 100;
  // padding-top: 116px;
  padding-top: 14px;
}

.tabComponent {
  position: relative;
  top: 0;
}

.tab-component {
  margin-bottom: 40px;
  background: #ffffff;
  // position: relative;
  width: inherit;
  nav {
    border-bottom: 3px solid #eceff4;
    padding-bottom: 10px;
    a {
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 400;
      color: #020202;
      border: 1px solid #fff;
    }
    a:hover {
      color: #134b7f !important;
    }
    .newclass {
      background: #e4e4e4 !important;
    }

    a.active {
      border-bottom: 3px solid #235499;
      color: #235499;
      transition: 0.1s;
    }

    &.transition-allowed {
      &.transition-in {
        animation: sticky-transition-in 0.5s;
        animation-fill-mode: forwards;
      }

      &.transition-out {
        animation: sticky-transition-out 700ms ease;
        // animation-direction: reverse;
      }
    }

    @keyframes sticky-transition-in {
      0% {
        transform: translateY(-160px);
        opacity: 0.25;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes sticky-transition-out {
      0% {
        transform: translateY(0);
        opacity: 1;
      }
      100% {
        transform: translateY(-160px);
        opacity: 0;
      }
    }
  }

  @media (max-width: 767px) {
    display: none !important;
  }
}
body {
  scroll-behavior: smooth;
}
</style>
